export const medicalCareConst = {
  path: "/single-programs/medical-care",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ЛЕЧЕБНОЕ ДЕЛО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Лечебное дело — путь к профессии врача</h2>
      <p>
        Лечебное дело — это фундаментальная медицинская программа, подготавливающая врачей общей практики и будущих специалистов по
        различным направлениям медицины. Это первая ступень к клинической карьере, дающая прочную научную и практическую базу.
      </p>
      <p>
        Обучение охватывает анатомию, физиологию, фармакологию, диагностику, терапию и основы клинического мышления. Особое внимание
        уделяется развитию навыков оказания неотложной помощи и коммуникации с пациентами.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Анатомия, физиология и гистология</li>
        <li>Патология, микробиология, фармакология</li>
        <li>Внутренние болезни и терапия</li>
        <li>Первая и неотложная помощь</li>
        <li>Диагностика и лечение распространенных заболеваний</li>
        <li>Клиническая практика в терапевтических отделениях</li>
        <li>Медицинская этика и профессиональная коммуникация</li>
        <li>Профилактика, вакцинация, ведение хронических пациентов</li>
        <li>Основы семейной медицины и амбулаторного приёма</li>
      </ul>
      <p>Практика проходит в клиниках, больницах, амбулаториях и скорой помощи под руководством опытных врачей.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Врач общей практики</li>
        <li>Терапевт в государственных и частных учреждениях</li>
        <li>Врач скорой и неотложной медицинской помощи</li>
        <li>Семейный врач</li>
        <li>Медицинский консультант в организациях и НКО</li>
        <li>Преподаватель базовых медицинских дисциплин</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Врачи — одна из самых уважаемых и востребованных профессий в мире.</p>
      <p>
        <strong>Средний доход в Европе — от €60,000 до €120,000 в год,</strong> в зависимости от специализации, опыта и региона.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в странах ЕС</li>
        <li>Возможность очного и дистанционного обучения</li>
        <li>Стажировки в ведущих клиниках и госпиталях Европы</li>
        <li>Интенсивная клиническая практика</li>
        <li>Индивидуальное сопровождение от поступления до трудоустройства</li>
        <li>Обучение на русском и английском языках</li>
      </ul>
      <h2>Учёба, приближенная к реальной практике</h2>
      <p>
        Наши студенты с первых курсов проходят клиническую подготовку, учатся работать в команде, принимать решения и нести ответственность
        за здоровье пациентов. Это путь в настоящую медицину.
      </p>
      <br />
      <p className="padding-left">«Лечебное дело — это призвание. Мы формируем профессионалов, которым доверяют жизни.»</p>
      <h2>Как поступить?</h2>
      <p>
        Заполните анкету, прикрепите необходимые документы — и приёмная комиссия свяжется с вами. Мы поможем на всех этапах поступления.{" "}
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Лечебное дело — путь к профессии врача
    Лечебное дело — это фундаментальная медицинская программа, подготавливающая врачей общей практики и будущих специалистов по различным направлениям медицины. Это первая ступень к клинической карьере, дающая прочную научную и практическую базу.
    Обучение охватывает анатомию, физиологию, фармакологию, диагностику, терапию и основы клинического мышления. Особое внимание уделяется развитию навыков оказания неотложной помощи и коммуникации с пациентами.

    Что вы будете изучать?
    • Анатомия, физиология и гистология
    • Патология, микробиология, фармакология
    • Внутренние болезни и терапия
    • Первая и неотложная помощь
    • Диагностика и лечение распространенных заболеваний
    • Клиническая практика в терапевтических отделениях
    • Медицинская этика и профессиональная коммуникация
    • Профилактика, вакцинация, ведение хронических пациентов
    • Основы семейной медицины и амбулаторного приёма
    Практика проходит в клиниках, больницах, амбулаториях и скорой помощи под руководством опытных врачей.


    Кем можно работать после окончания?
    • Врач общей практики
    • Терапевт в государственных и частных учреждениях
    • Врач скорой и неотложной медицинской помощи
    • Семейный врач
    • Медицинский консультант в организациях и НКО
    • Преподаватель базовых медицинских дисциплин

    Востребованность и доход
    Врачи — одна из самых уважаемых и востребованных профессий в мире.
    Средний доход в Европе — от €60,000 до €120,000 в год, в зависимости от специализации, опыта и региона.

    Почему выбирают нас?
    • Европейский диплом, признанный в странах ЕС
    • Возможность очного и дистанционного обучения
    • Стажировки в ведущих клиниках и госпиталях Европы
    • Интенсивная клиническая практика
    • Индивидуальное сопровождение от поступления до трудоустройства
    • Обучение на русском и английском языках

    Учёба, приближенная к реальной практике
    Наши студенты с первых курсов проходят клиническую подготовку, учатся работать в команде, принимать решения и нести ответственность за здоровье пациентов. Это путь в настоящую медицину.
    «Лечебное дело — это призвание. Мы формируем профессионалов, которым доверяют жизни.»
    Как поступить?
    Заполните анкету, прикрепите необходимые документы — и приёмная комиссия свяжется с вами. Мы поможем на всех этапах поступления. 
  `,
};
